module.exports = __webpack_public_path__ + "img/SET_COMO_DUO.67915f76.jpg";